module.exports = __webpack_public_path__ + "img/Firmware_Version.beecd5a6.jpg";